import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export type BasicListNavigatorMenuItemParams = {
  id: number;
  caption?: string;
  name: string;
};

export function BasicListNavigatorMenuItem({
  item,
}: {
  item: BasicListNavigatorMenuItemParams;
}) {
  return (
    <Stack>
      <Typography variant="subtitle2" component="span">
        {item.name}
      </Typography>
      {item?.caption && (
        <Typography variant="caption">{item?.caption}</Typography>
      )}
    </Stack>
  );
}
